import Axios from "@/plugins/Axios";
import Plano from "../Models/Plano";

export class PlanosService {
  async index(pageNumber, query, turma, disciplina, semestre) {
    const planos = await Axios().get(
      `planos/planos-semestrais?page=${pageNumber}&query=${query}&turma=${turma}&disciplina=${disciplina}&semestre=${semestre}`
    );
    const response = planos.data.data.map((plano) => new Plano(plano));
    return { planos: response, data: planos.data };
  }

  async show(planoId) {
    const plano = await Axios().get(`planos/planos-bimestrais/${planoId}/visualizar`);
    const response = new Plano(plano.data.planoBimestral);
    return response;
  }

  async showSemestral(planoId) {
    const plano = await Axios().get(`planos/planos-semestrais/${planoId}/visualizar`);
    const response = new Plano(plano.data.planoSemestral);
    return response;
  }

  async update(planoId, statusId) {
    const response = await Axios().put(
      `planos/planos-bimestrais/${planoId}/${statusId}/atualizarSituacao`
    );
    return response.data;
  }

  async updateSemestral(planoId, statusId) {
    const response = await Axios().put(
      `planos/planos-semestrais/${planoId}/${statusId}/atualizarSituacao`
    );
    return response.data;
  }

  async disciplinas() {
    const response = await Axios().get(`planos/planos-bimestrais/disciplinas`);
    return response;
  }

  async turmas() {
    const response = await Axios().get(`planos/planos-bimestrais/turmas`);
    return response;
  }

  async meses() {
    const response = await Axios().get(`planos/planos-bimestrais/listarMeses`);
    return response;
  }

  async bimestres() {
    const response = await Axios().get(`planos/planos-bimestrais/listarBimestres`);
    return response;
  }

  // infantil
  async turmasInfantil() {
    const response = await Axios().get(`planos/planos-bimestrais-infantil/turmas-infantil`);
    return response;
  }

  async bimestresInfantil() {
    const response = await Axios().get(
      `planos/planos-bimestrais-infantil/listar-bimestres-infantil`
    );
    return response;
  }

  // async indexInfantil(pageNumber, query, turma, disciplina, bimestre) {
  //   const planos = await Axios().get(
  //     `planos/planos-bimestrais-infantil?page=${pageNumber}&query=${query}&turma=${turma}&disciplina=${disciplina}&bimestre=${bimestre}`
  //   );
  //   const response = planos.data.planos.data.map((plano) => new Plano(plano));
  //   return { planos: response, data: planos.data.planos };
  // }

  async indexInfantil(pageNumber, query, turma, disciplina, semestre) {
    const planos = await Axios().get(
      `planos/planos-semestrais-infantil?page=${pageNumber}&query=${query}&turma=${turma}&disciplina=${disciplina}&semestre=${semestre}`
    );
    const response = planos.data.planos.data.map((plano) => new Plano(plano));
    return { planos: response, data: planos.data.planos };
  }

  async updateInfantil(planoId, statusId) {
    const response = await Axios().put(
      `planos/planos-bimestrais-infantil/${planoId}/${statusId}/atualizarSituacao`
    );
    return response.data.plano;
  }

  async updateSemestralInfantil(planoId, statusId) {
    const response = await Axios().put(
      `planos/planos-semestrais-infantil/${planoId}/${statusId}/atualizarSituacao`
    );
    return response.data.plano;
  }

  async showInfantil(planoId) {
    const response = await Axios().get(`planos/planos-bimestrais-infantil/${planoId}/visualizar`);
    return response;
  }

  async showSemestralInfantil(planoId) {
    const response = await Axios().get(`planos/planos-semestrais-infantil/${planoId}/visualizar`);
    return response;
  }

  async pdf(planoId) {
    const base64 = await Axios()
      .get(`planos/planos-bimestrais/${planoId}/relatorio`, { responseType: "arraybuffer" })
      .then((response) => Buffer.from(response.data, "binary").toString("base64"));

    return `data:application/pdf;base64, ${base64}`;
  }

  async pdfSemestral(planoId) {
    const base64 = await Axios()
      .get(`planos/planos-semestrais/${planoId}/relatorio`, { responseType: "arraybuffer" })
      .then((response) => Buffer.from(response.data, "binary").toString("base64"));

    return `data:application/pdf;base64, ${base64}`;
  }

  async pdfInfantil(planoId) {
    const base64 = await Axios()
      .get(`planos/planos-bimestrais-infantil/${planoId}/relatorio`, {
        responseType: "arraybuffer",
      })
      .then((response) => Buffer.from(response.data, "binary").toString("base64"));

    return `data:application/pdf;base64, ${base64}`;
  }

  async pdfSemestralInfantil(planoId) {
    const base64 = await Axios()
      .get(`planos/planos-semestrais-infantil/${planoId}/relatorio`, {
        responseType: "arraybuffer",
      })
      .then((response) => Buffer.from(response.data, "binary").toString("base64"));

    return `data:application/pdf;base64, ${base64}`;
  }

  async indexPlanoBimestral(pageNumber, query, turma, disciplina, etapa_id) {
    const planos = await Axios().get(
      `planos/planos-bimestrais?page=${pageNumber}&query=${query}&turma=${turma}&disciplina=${disciplina}&etapa_id=${etapa_id}`
    );
    const response = planos.data.data.map((plano) => new Plano(plano));
    return { planos: response, data: planos.data };
  }

  async visualizarPdfPlanoBimestral(gestao_id, etapa_id, disciplina_id) {
    const response = await Axios().get(
      `relatorios/plano-bimestral/${gestao_id}/${etapa_id}/${disciplina_id}`,
      { responseType: "arraybuffer" }
    );

    const base64 = Buffer.from(response.data, "binary").toString("base64");
    return `data:application/pdf;base64,${base64}`;
  }

  async indexInfantilBimestre(pageNumber, query, turma, disciplina, etapa_id) {
    const planos = await Axios().get(
      `planos/planos-bimestrais-infantil?page=${pageNumber}&query=${query}&turma=${turma}&disciplina=${disciplina}&etapa_id=${etapa_id}`
    );
    const response = planos.data.planos.data.map((plano) => new Plano(plano));
    return { planos: response, data: planos.data.planos };
  }

  async showBimestralInfantil(planoId) {
    const response = await Axios().get(`planos/planos-bimestrais-infantil/${planoId}/visualizar`);
    return response;
  }

  async updateBimestral(planoId, statusId) {
    const response = await Axios().put(
      `planos/planos-bimestrais/${planoId}/${statusId}/atualizarSituacao`
    );
    return response.data;
  }

  async updateBimestralInfantil(planoId, statusId) {
    const response = await Axios().put(
      `planos/planos-bimestrais-infantil/${planoId}/${statusId}/atualizarSituacao`
    );
    return response.data.plano;
  }
}

export default new PlanosService();
